import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendSettingsNavigationItemClickedEvent } from 'utils/analytics-events';

interface UseAboutCignaReturn {
  handleGoBack: () => void;
}

export const useAboutCigna = (): UseAboutCignaReturn => {
  const navigate = useNavigate();

  useEffect(() => {
    sendSettingsNavigationItemClickedEvent('about company');
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  return {
    handleGoBack,
  };
};
